import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import StatsBanner from "./StatsBanner";

const TopBar = ({ stats, statsLoading, cap, totalCap, onCapChange, onNewClick, readOnly = false }) => {
  const theme  = useTheme();
  const t      = theme.custom;
  const isDark = theme.palette.mode === "dark";

  return (
    <Box sx={{
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "16px 20px", borderBottom: `1px solid ${t.border2}`,
      gap: "16px", flexWrap: "wrap",
    }}>
      <StatsBanner
  stats={stats}
  statsLoading={statsLoading}
  cap={cap}
  totalCap={totalCap}
  onCapChange={onCapChange}
  readOnly={readOnly}
/>

      <Box sx={{ display: "flex", gap: "10px", flexShrink: 0, ml: "auto" }}>
        {/* Export — wired up later */}
        

        {/* Opens new position drawer */}
{onNewClick && (
  <Box
    onClick={onNewClick}
    sx={{
      display: "flex", alignItems: "center", gap: "6px",
      padding: "8px 18px", borderRadius: "4px", cursor: "pointer",
      background: t.accent,
      fontFamily: "'DM Mono', monospace", fontSize: "11px", fontWeight: 600,
      color: isDark ? "#060E0D" : "#fff",
      transition: "opacity 0.15s",
      "&:hover": { opacity: 0.88 },
    }}
  >
    + New Position ID
  </Box>
)}
      </Box>
    </Box>
  );
};

export default TopBar;